(() => {
  const WIDGET_SELECTORS = [
    '.recharge-subscription-widget',
    '.rc-container',
    '.rc_container',
    '.rc-container-wrapper',
    '.rc_container_wrapper',
    '[id^="RechargeWidget_"]',
    '.rc-widget',
    '.rc-widget-injection-parent',
    '.rc-widget-container',
    '.rc-subscription-widget',
    '.rc-widget-wrapper',
    '.rc_widget',
    '.rc_widget__option',
    '.rc-option-container',
    '.rc-radio-group',
    '[data-recharge-widget]',
    '[data-widget="recharge"]',
    '[data-recharge-container]',
    '[data-recharge-mount]',
    '#recharge-subscription-widget'
  ];

  const RADIO_SELECTOR = [
    '.rc-radio input[type="radio"]',
    '.rc-radio__input',
    '.rc_widget__option__input',
    '.rc-widget input[name="purchase_option"]',
    '.rc-widget input[name="purchaseOption"]',
    '.rc-widget input[name^="selling_plan_"]',
    '.rc-container input[name^="selling_plan_"]',
    'input[name="purchase_option"]',
    'input[name="purchaseOption"]',
    'input[name^="selling_plan_"]'
  ].join(', ');

  const OBSERVER_CONFIG = { childList: true, subtree: true };
  let observer = null;

  const triggerChange = (element) => {
    if (!element) return;
    try {
      element.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (error) {
      const fallbackEvent = document.createEvent('Event');
      fallbackEvent.initEvent('change', true, true);
      element.dispatchEvent(fallbackEvent);
    }
  };

  const markSentinel = () => {
    document.querySelectorAll('[data-recharge-sentinel]').forEach((node) => {
      node.setAttribute('data-recharge-ready', 'false');
    });
  };

  const enforceOneTime = () => {
    document.querySelectorAll(RADIO_SELECTOR).forEach((input) => {
      if (!input) return;

      const rawValue = (input.value || '').toLowerCase();
      const isDatasetOneTime =
        input.dataset.radioOnetime !== undefined ||
        input.dataset.onetime !== undefined ||
        input.getAttribute('data-plan-onetime') !== null;
      const isIdOneTime = input.id?.toLowerCase().includes('onetime');
      const isOneTime =
        rawValue === 'onetime' ||
        rawValue === 'one-time' ||
        isDatasetOneTime ||
        isIdOneTime;

      if (!isOneTime) {
        if (input.checked) {
          input.checked = false;
          triggerChange(input);
        }
        input.disabled = true;
      } else {
        if (!input.checked) {
          input.checked = true;
          triggerChange(input);
        }
        input.disabled = false;
      }
    });

    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput) {
      if (sellingPlanInput.value !== '') {
        sellingPlanInput.value = '';
        triggerChange(sellingPlanInput);
      }
      sellingPlanInput.setAttribute('data-recharge-blocked', 'true');
    }
  };

  const removeWidgets = () => {
    const sentinel = document.querySelector('[data-recharge-sentinel]');
    WIDGET_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        if (sentinel && node.closest('[data-recharge-sentinel]')) return;
        node.remove();
      });
    });

    markSentinel();
    enforceOneTime();
  };

  const teardownObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const runGuard = () => {
    const sentinel = document.querySelector('[data-recharge-sentinel]');
    const body = document.body;
    const isProductTemplate = body?.classList.contains('template-product');
    const hasProductForm = document.querySelector('form[action^="/cart/add"]');

    if (!sentinel || (!isProductTemplate && !hasProductForm)) {
      teardownObserver();
      document.documentElement?.removeAttribute('data-recharge-blocked');
      body?.removeAttribute('data-recharge-blocked');
      return;
    }

    document.documentElement?.setAttribute('data-recharge-blocked', 'true');
    body?.setAttribute('data-recharge-blocked', 'true');

    removeWidgets();
    teardownObserver();

    if (document.body) {
      observer = new MutationObserver(removeWidgets);
      observer.observe(document.body, OBSERVER_CONFIG);
    }
  };

  const init = () => {
    runGuard();
    document.addEventListener('shopify:section:load', runGuard);
    document.addEventListener('shopify:section:reorder', runGuard);
    document.addEventListener('shopify:section:unload', runGuard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
